import gql from 'graphql-tag';

export const updateContactInfoConfirmation = gql`
  mutation updateContactInfoConfirmation(
    $payload: ContactInfoConfirmationRequest!
  ) {
    updateContactInfoConfirmation(payload: $payload) {
      success
    }
  }
`;
